import { NgModule } from '@angular/core';
import { WeissmanSharedModule } from '../Common/weissman-shared.module';
import { HybridAdapterUtility } from '../Hybrid/hybrid-adapter.utility';
import { IncomeStatementCategoryPickerComponent } from './Income-Statement/Income-Statement-Category-Selector/incomeStatementCategoryPicker.component';
import { IncomeStatementCategorySelectorComponent } from './Income-Statement/Income-Statement-Category-Selector/incomeStatementCategorySelector.component';
import { IncomeStatementListComponent } from './Income-Statement/Income-Statement-List/incomeStatementList.component';
import { RentRollGridActionCellRendererComponent } from './Rent-Roll/Rent-Roll-List/agGridActionCellRendererComponent';
import { RentRollListComponent } from './Rent-Roll/Rent-Roll-List/rentRollList.component';
import { ValuationTemplatesModule } from './Templates/valuationTemplates.module';
import { IncomeStatementBulkUpdateComponent } from './Income-Statement/Income-Statement-Bulk-Update/incomeStatementBulkUpdate.component';
import { RentRollBulkUpdateComponent } from './Rent-Roll/Rent-Roll-Bulk-Update/rentRollBulkUpdate.component';

@NgModule({
    imports: [
        WeissmanSharedModule,
        ValuationTemplatesModule
    ],
    declarations: [
        IncomeStatementCategorySelectorComponent,
        IncomeStatementCategoryPickerComponent,
        IncomeStatementListComponent,
        RentRollGridActionCellRendererComponent,
        RentRollListComponent,
        IncomeStatementBulkUpdateComponent,
        RentRollBulkUpdateComponent
    ],
    exports: [
        ValuationTemplatesModule,
        IncomeStatementCategorySelectorComponent,
        IncomeStatementListComponent,
        RentRollListComponent,
        IncomeStatementBulkUpdateComponent,
        RentRollBulkUpdateComponent
    ]
})
export class ValuationModule {
    static setupModule() {
        ValuationTemplatesModule.setupModule();

        const hybridAdapterUtility = new HybridAdapterUtility();

        hybridAdapterUtility.downgradeNg2Component('incomeStatementList', IncomeStatementListComponent);
        hybridAdapterUtility.downgradeNg2Component('rentRollList', RentRollListComponent);
    }
}
